import agreementTypes from "astrid-firestore/src/api/agreements/constants/agreementTypes";

import useForm from "../../../../forms/hooks/useForm";

// `defaults` fill in what neither agreement nor template sets, e.g. the cloud agreement skeleton.
export default function useAgreementsForm({ template, agreement, organization, defaults = {} }) {
	const type = agreement?.type || template?.type || defaults.type || agreementTypes.FRAMEWORK;

	return useForm({
		defaultValues: {
			name: agreement?.name || template?.name || defaults.name || "",
			type,
			// Cloud agreements are signed outside Astrid and uploaded.
			signed: type === agreementTypes.CLOUD,
			part: agreement?.part || template?.part || defaults.part,
			life: agreement?.life || template?.life || defaults.life || 365,
			prices: Object.values(agreement?.prices || template?.prices || defaults.prices || {}),
			parties: agreement?.secondParty
				? {
						[`${agreement.secondParty.id}-${agreement.secondParty.vendor.id}`]: agreement.secondParty,
				  }
				: {},
			daysToSign: 14,
			activeFrom: new Date(),
			firstSigneeId: null,
			firstPartyVendorId: agreement?.firstParty?.vendor?.id || null,
			canManageAgreements: agreement?.canManageAgreements || template?.canManageAgreements || false,
			appendixes: agreement?.appendixes || template?.appendixes || [],
			agreement,
			template,
			producer: organization,
			firstParty: organization,
		},
	});
}
